import { Component, input } from '@angular/core'
import { StringMap } from '@naturalcycles/js-lib'

@Component({
  template: ` <p [innerHTML]="api().messageKey | tmd: api().messageParams | safe"></p> `,
  standalone: false,
})
export class SimpleModalComponent {
  protected api = input.required<{
    messageKey: string
    messageParams?: StringMap
  }>()
}
